import { Descriptions } from "antd";
import { TypeViagem } from "../../../../../Models/Domain/Viagem/Viagem";
import { Formatacoes } from "../../../../../Utils/Formatacao";

export const DescricaoDaViagem: React.FC<{
    viagem: TypeViagem,
    ocultarTitulo?: boolean,
    ocultarDescricao?: boolean,
}> = (props) => {
    return <div dangerouslySetInnerHTML={{ __html: props.viagem.descricao ?? ""}}></div>;
    // return <Descriptions
    //     title={ props.ocultarTitulo? undefined : <>{props.viagem.titulo}</>}
    //     bordered
    //     column={{ xs: 1, sm: 1, md: 2, lg: 4 }}
    //     layout="vertical"
    //     items={[
    //         {
    //             key: "titulo",
    //             label: "Título",
    //             span: { md: 2, lg: 4 },
    //             children: <>{props.viagem.titulo ?? "N/A"}</>
    //         },
    //         props.ocultarDescricao !== true && {
    //             key: "descricao",
    //             label: "Descrição",
    //             span: { md: 2, lg: 4 },
    //             children: <>{props.viagem.descricao ?? "N/A"}</>
    //         },
    //         {
    //             key: "tipo-de-viagem",
    //             label: "Tipo de viagem",
    //             span: { lg: 2 },
    //             children: <>{props.viagem.tipoDeViagem?.nome}</>
    //         },
    //         {
    //             key: "status",
    //             label: "Status",
    //             span: { lg: 2 },
    //             children: <>{props.viagem.status?.descricao}</>
    //         },
    //         {
    //             key: "escola-nome",
    //             label: "Escola",
    //             span: { lg: 2 },
    //             children: <> {props.viagem.escola?.pessoa?.nome} </>
    //         },
    //         {
    //             key: "escola-nome-social",
    //             label: "Escola (nome social)",
    //             span: { lg: 2 },
    //             children: <> {props.viagem.escola?.pessoa?.nomeSocial} </>
    //         },
    //         {
    //             key: "turma",
    //             label: "Turma",
    //             span: { lg: 2 },
    //             children: <>{props.viagem.turma}</>
    //         },
    //         {
    //             key: "destino",
    //             label: "Destino",
    //             span: { lg: 2 },
    //             children: <>{props.viagem.destino?.nome}</>
    //         },
    //         {
    //             key: "data-inicio",
    //             label: "Início da viagem",
    //             children: <>{Formatacoes.paraData(props.viagem.inicio)?.toLocaleDateString() ?? "N/A"}</>
    //         },
    //         {
    //             key: "data-fim",
    //             label: "Término da viagem",
    //             children: <>{Formatacoes.paraData(props.viagem.fim)?.toLocaleDateString() ?? "N/A"}</>
    //         },
    //         {
    //             key: "prazo-inscricao",
    //             label: "Prazo de inscrição",
    //             children: <>{Formatacoes.paraData(props.viagem.prazoDeInscricao)?.toLocaleDateString() ?? "N/A"}</>
    //         },

    //         {
    //             key: "descricao",
    //             label: "Descrição",
    //             span: { lg: 4 },
    //             children: <><div dangerouslySetInnerHTML={{ __html: props.viagem.descricao ?? ""}}></div></>
    //         },

    //     ].filter((v) => v !== false)}
    // />
}
